import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContactList from '@/connectHOCs/Contacts/ContactList';
import ContactProxy from '@/Proxies/ContactProxy';
import cssStyles from './ContactPills.css';

class ContactPills extends Component {
  static propTypes = {
    contactIds: PropTypes.array,
    ownerGuid: PropTypes.string,
    contacts: PropTypes.array,
  };

  static defaultProps = {
    contactIds: [],
    ownerGuid: '',
    contacts: [],
  };

  contactProxySubscription = undefined;

  constructor(props) {
    super();

    const { ownerGuid, contactIds } = props;
    this.contactProxySubscription = ContactProxy.subscribe(
      ownerGuid,
      contactIds
    );
  }

  componentDidUpdate() {
    const { ownerGuid, contactIds } = this.props;
    this.contactProxySubscription.update(ownerGuid, contactIds);
  }

  componentWillUnmount() {
    if (this.contactProxySubscription) {
      this.contactProxySubscription.unsubscribe();
    }
  }

  render() {
    const { contacts: selectedContacts } = this.props;

    if (selectedContacts.length <= 0) {
      return null;
    }
    return (
      <div className={cssStyles.pills}>
        {selectedContacts.map(c => (
          <span key={c.id}>{c.name}</span>
        ))}
      </div>
    );
  }
}

export default ContactList(ContactPills, 'contactIds', 'ownerGuid');



// WEBPACK FOOTER //
// ./src/components/Search/ContactSearch/SearchInput/ContactPills/ContactPills.js